import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from '../components/NavMenu';
import "./css/Layout.css";
import { withTranslation } from 'react-i18next';

class Layout extends Component {
    changeLanguage = (lng) => {
        const { t, i18n } = this.props;
        i18n.changeLanguage(lng);
    };
    render() {
        return (
            <div className="layout">
                <NavMenu />
                {/* <div className='translation'>
                    <button onClick={() => this.changeLanguage("zh")}>中文</button>
                    <button onClick={() => this.changeLanguage("en")}>English</button>
                </div> */}
                {this.props.children}
            </div>
        );
    }
}

export default withTranslation()(Layout);